import { APIPropTypes, PropTypes, React, connect } from 'imports';
import { RequestStatus } from 'utils/constants';
import { FormattedResource, MarkdownBlock, Spinner, TimeStamp, User } from 'components/common';
import './Comment.less';

class Comment extends React.PureComponent {

    static get commentPropType() {
        return PropTypes.shape({
            Comment: PropTypes.string.isRequired,
            UserID: PropTypes.number.isRequired,
            DateAdded: PropTypes.instanceOf(Date),
            ReplyToCommentID: PropTypes.number,
            Custom: APIPropTypes.networkObjectCustom.isRequired
        });
    }

    static get propTypes() {
        return {
            className: PropTypes.string,
            comment: Comment.commentPropType.isRequired,
            showDate: PropTypes.bool,
            isReplying: PropTypes.bool,
            isActionsActive: PropTypes.bool,
            onReplyClick: PropTypes.func,
            onCancelClick: PropTypes.func,
            onRetryClick: PropTypes.func,
            onEditClick: PropTypes.func,

            session: APIPropTypes.SessionInformation.isRequired
        };
    }

    static get defaultProps() {
        return {
            className: '',
            showDate: false,
            isReplying: false,
            isActionsActive: true
        };
    }

    _onEditClick = () => {
        if (this.props.onEditClick) {
            this.props.onEditClick(this);
        }
    };

    _onReplyClick = () => {
        if (this.props.onReplyClick) {
            this.props.onReplyClick(this, this.props.comment);
        }
    };

    _onCancelClick = () => {
        if (this.props.onCancelClick) {
            this.props.onCancelClick(this, this.props.comment);
        }
    };

    _onRetryClick = () => {
        if (this.props.onRetryClick) {
            this.props.onRetryClick(this, this.props.comment);
        }
    };

    _renderMultiline(text) {
        return <MarkdownBlock className="comment" value={text} inline />;
    }

    _renderTimeStamp() {
        switch (this.props.comment.Custom.status) {
            case RequestStatus.SUCCEEDED:
                return this.props.showDate ? <TimeStamp value={this.props.comment.DateAdded} /> : null;

            case RequestStatus.UNSYNCED:
            case RequestStatus.PENDING:
                return <Spinner config={{ scale: 0.0625 }} />;

            case RequestStatus.FAILED:
            default:
                return null;
        }
    }

    render() {
        const
            { className, comment, isReplying, session } = this.props,
            editable = !!this.props.onEditClick && comment.UserID === session.UserID;

        return (
            <div className={`comment flex-row${className ? ` ${className}` : ''}${comment.ReplyToCommentID ? ' reply' : ''}`}>
                {
                    comment.Custom.status === RequestStatus.FAILED ?
                        <div className="failed-overlay">
                            <div className="centered">
                                <FormattedResource resource={{ id: 'newsfeed.comment.post_error' }} />
                                <button className="primary" onClick={this._onRetryClick}>
                                    <FormattedResource resource={{ id: 'common.retry' }} />
                                </button>
                            </div>
                        </div> :
                        null
                }
                <User userID={comment.UserID} firstNameVisible={false} lastNameVisible={false} />
                <div className="message main-col">
                    {
                        editable ?
                            <button className="fa fa-pencil edit-btn" onClick={this._onEditClick} /> :
                            null
                    }
                    <User userID={comment.UserID} pictureVisible={false} />{' '}{this._renderMultiline(comment.Comment)}
                    {
                        this.props.isActionsActive && !comment.ReplyToCommentID && !isReplying ?
                            <div className="reply">
                                <button className="inline" onClick={this._onReplyClick}>
                                    <FormattedResource resource={{ id: 'common.reply' }} />
                                </button>
                            </div> :
                            isReplying ?
                                <div className="cancel">
                                    <button className="inline" onClick={this._onCancelClick}>
                                        <FormattedResource resource={{ id: 'common.cancel' }} />
                                    </button>
                                </div> :
                                null
                    }
                </div>
                {this._renderTimeStamp()}
            </div>
        );
    }
}

export default connect()(Comment);
